import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SendDataServiceService {

  constructor() { }

  public buttonClickedSource = new Subject<any>();
  buttonClicked$ = this.buttonClickedSource.asObservable();

  public crossIconClickedSource = new Subject<any>();
  crossIconClicked$ = this.crossIconClickedSource.asObservable();

  triggerButtonClick(params: any) {
    this.buttonClickedSource.next(params);
  }
  triggerCrossIconClick(params: any) {
    this.crossIconClickedSource.next(params);
  }
}
